import { FC } from 'react';
import { RepeatIcon } from '@chakra-ui/icons';
import { Button, useToast } from '@chakra-ui/react';
import { useSplunkLogger } from '@resolutionlife/ui';

import { useRetryFileProcessesMutation } from '../../graphql/generated';

type FileProcessesRetryProps = { fileId: string };

export const FileProcessesRetry: FC<FileProcessesRetryProps> = ({ fileId }) => {
  const toast = useToast();
  const splunkLogger = useSplunkLogger();
  const [retryProcesses, { loading }] = useRetryFileProcessesMutation({
    variables: { fileId },
    refetchQueries: ['GetFile'],
    awaitRefetchQueries: true,
  });

  const handleRetry = async () => {
    try {
      await retryProcesses();
    } catch {
      toast({
        title: 'Could not retry the processes',
        description: 'Please try again',
        status: 'error',
        position: 'bottom',
      });
      splunkLogger.error('File processes retry failed', { eventCategory: 'file_operation_error', fileId });
    }
  };

  return (
    <Button
      onClick={handleRetry}
      isLoading={loading}
      leftIcon={<RepeatIcon />}
      colorScheme="blue"
      size="lg"
      variant="ghost"
      data-testid="retry-processes-button"
    >
      Retry File Processing
    </Button>
  );
};
